import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { Row, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import {
  AccountBackground,
  LogoContainer,
  AccountContainer,
  LogoImage,
  LogoText,
} from "./AccountElements.js";
import Login from "../../components/Login/index.js";
import LogoArian from "../../assets/logo/Logo.svg";
import LogoTextImg from "../../assets/logo/Ariane in white.svg";

const Account = () => {
  const navigate = useNavigate();
  const user = useSelector((state) => state.userSlice.user);

  window.scroll({
    top: 0,
    left: 0,
    behavior: "smooth",
  });

  useEffect(() => {
    const root = document.documentElement;
    root?.style.setProperty("--text-color", "#000");
  }, []);

  useEffect(() => {
    if (user) {
      navigate("/");
    }
  }, [navigate, user]);

  const toLanding = () => {
    navigate("/");
    // window.location.reload(true);
  };

  return (
    <AccountBackground
      style={{
        background:
          "linear-gradient(90deg, #281a4b 0%, #281a4b 15%, #314f8b 100%)",
        height: "100vh",
        position: "relative",
        display: "flex",
        flexDirection: "row",
        flexWrap: "nowrap",
        justifyContent: "center",
        alignItems: "center",
        alignContent: "center",
      }}
    >
      <LogoContainer
        onClick={() => {
          toLanding();
        }}
      >
        <LogoImage src={LogoArian} />
        <br />
        <LogoText src={LogoTextImg} />
      </LogoContainer>

      <AccountContainer>
        <Row
          style={{
            display: "flex",
            flexDirection: "row",
            flexWrap: "nowrap",
            justifyContent: "space-evenly",
            alignItems: "center",
            alignContent: "stretch",
          }}
        >
          <Col>
            <Row>
              <Login />
            </Row>
          </Col>
        </Row>
      </AccountContainer>
    </AccountBackground>
  );
};

export default Account;
